import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import MovieGridSection from "./components/MovieGridSection";
import TvSection from "./components/TvSection";
import EditorPicksSection from "./components/EditorPicksSection";
import EthicalSection from "./components/EthicalSection";
import ResourceSection from "./components/ResourceSection";
import RankingSection from "./components/RankingSection";
import GenreNavSection from "./components/GenreNavSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <StatsSection />
        <MovieGridSection />
        <TvSection />
        <EditorPicksSection />
        <EthicalSection />
        <ResourceSection />
        <RankingSection />
        <GenreNavSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}